import { useMutation } from "@tanstack/react-query";
import { login } from "@/apis/oneclub/services/members";

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: login,
  });
};
